import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { backend, producturl } from "../../../path";
import DashboardSidebarMain from "../dashsidebar";

import Pagination from "../../components/pagination";
import styled from "styled-components";
import OrderChart from "./Graph";
import { initGA, logPageView } from "./Analytics";
function UserNew() {
  // const [formData, setFormData] = useState([]);
  const [formData, setFormData] = useState({
    category_name: "",
    description: "", // Assuming description is a string
    logo: "", // Assuming logo is a string
  });
  const [data, setData] = useState([]);
  const [error, setError] = useState();
  const [loading, setLoading] = useState();
  const [view, setView] = useState(0);
  const [logo, setLogo] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [dummyData, setDummyData] = useState({});
  const [authenticated, setAuthenticated] = useState(
    JSON.parse(localStorage.getItem("userdata"))
  );
  const [newPageNumber, setNewPageNumber] = useState(99999);
  const [searchInput, setSearchInput] = useState("");
  const searchParams = new URLSearchParams({
    // page_number: pageNumber,
    page_size: newPageNumber,
    search: searchInput,
  });
  useEffect(() => {
    initGA();
    logPageView();
  }, []);
  const [allOrders, setAllOrders] = useState(null);
  const [activeOrders, setactiveOrders] = useState(null);
  const [pendingOrders, setpendingeOrders] = useState(null);
  const [canceledOrders, setcanceledOrders] = useState(null);
  const [completedOrders, setcompletedOrders] = useState(null);
  const fetchData = () => {
    // Assuming setData, setError, and setLoading are state functions from useState
    setLoading(true);

    fetch(
      backend +
        "getuserlog?page_number=" +
        pageNumber +
        "&page_size=" +
        pageSize,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authenticated?.access_token}`,
        },
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setData(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const fetchAllOrders = async () => {
    try {
      const response = await fetch(backend + "getallorders?" + searchParams, {
        method: "GET",
      });
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setAllOrders(data);
    } catch (error) {
      console.error("Error fetching confirmed orders:", error);
    }
  };
  const fetchActiveOrders = async () => {
    try {
      const response = await fetch(
        backend + "getcurrentorders?" + searchParams,
        {
          method: "GET",
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setactiveOrders(data);
    } catch (error) {
      console.error("Error fetching confirmed orders:", error);
    }
  };
  const fetchPendingOrders = async () => {
    try {
      const response = await fetch(
        backend + "getpendingorders?" + searchParams,
        {
          method: "GET",
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setpendingeOrders(data);
    } catch (error) {
      console.error("Error fetching confirmed orders:", error);
    }
  };
  const fetchCanceledOrders = async () => {
    try {
      const response = await fetch(
        backend + "getcancelledorders?" + searchParams,
        {
          method: "GET",
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setcanceledOrders(data);
    } catch (error) {
      console.error("Error fetching confirmed orders:", error);
    }
  };
  const fetchCompletedOrders = async () => {
    try {
      const response = await fetch(
        backend + "getdeliveredorders?" + searchParams,
        {
          method: "GET",
        }
      );
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      setcompletedOrders(data);
    } catch (error) {
      console.error("Error fetching confirmed orders:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pageNumber, pageSize]);

  useEffect(() => {
    fetchAllOrders();
    fetchActiveOrders();
    fetchPendingOrders();
    fetchPendingOrders();
    fetchCanceledOrders();
    fetchCompletedOrders();
  }, []);
  console.log(allOrders);

  const handlePageClick = (pageNumber) => {
    setPageNumber(pageNumber);
  };

  return (
    <DashboardContainer>
      <DashboardSidebarMain />
      <MainPanel>
        {/* Header Row */}
        <HeaderRow>
          <div>
            <span className="subtitle">Consumers & Ordering</span>
            <h2 className="title">Order Analytics Dashboard</h2>
          </div>
        </HeaderRow>

        <BoxContainer>
          <Box>
            <div className="left total">
              <Icon icon="solar:cart-large-bold" />
            </div>
            <div className="right">
              <H3>{allOrders?.data?.length || 0}</H3>
              <P>Total Orders</P>
            </div>
          </Box>
          <Box>
            <div className="left confirmed">
              <Icon icon="solar:check-circle-bold" />
            </div>
            <div className="right">
              <H3>{activeOrders?.data?.length || 0}</H3>
              <P>Confirmed Orders</P>
            </div>
          </Box>
          <Box>
            <div className="left pending">
              <Icon icon="solar:clock-circle-bold" />
            </div>
            <div className="right">
              <H3>{pendingOrders?.data?.length || 0}</H3>
              <P>Pending Orders</P>
            </div>
          </Box>
          <Box>
            <div className="left canceled">
              <Icon icon="solar:close-circle-bold" />
            </div>
            <div className="right">
              <H3>{canceledOrders?.data?.length || 0}</H3>
              <P>Canceled Orders</P>
            </div>
          </Box>
          <Box>
            <div className="left completed">
              <Icon icon="solar:box-delivery-bold" />
            </div>
            <div className="right">
              <H3>{completedOrders?.data?.length || 0}</H3>
              <P>Delivered Orders</P>
            </div>
          </Box>
        </BoxContainer>

        <OrderChart orders={allOrders} producturl={producturl} />
      </MainPanel>
      <ToastContainer />
    </DashboardContainer>
  );
}

export default UserNew;

const DashboardContainer = styled.div`
  display: flex;
  background: #FDFBF7;
  min-height: 100vh;
  font-family: "Jost", sans-serif;
  width: 100%;
`;

const MainPanel = styled.div`
  flex: 1;
  padding: 40px;
  background: #FDFBF7;
  overflow-x: hidden;

  @media (max-width: 980px) {
    padding: 20px;
  }
`;

const HeaderRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  border-bottom: 1px solid rgba(197, 168, 128, 0.15);
  padding-bottom: 20px;

  .subtitle {
    font-size: 13px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: #c5a880;
    text-align: left;
    display: block;
  }

  .title {
    font-family: "Playfair Display", serif;
    font-size: 32px;
    font-weight: 700;
    color: #123524;
    margin: 5px 0 0;
    text-align: left;
  }
`;

const BoxContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
  margin-bottom: 30px;

  @media screen and (max-width: 1400px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
  @media screen and (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

const Box = styled.div`
  background: #FFFFFF;
  border: 1px solid rgba(197, 168, 128, 0.15);
  padding: 20px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(45, 31, 24, 0.02);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 30px rgba(197, 168, 128, 0.08);
    border-color: #123524;
  }

  .left {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 46px;
    height: 46px;
    border-radius: 12px;
    font-size: 24px;
    flex-shrink: 0;

    &.total {
      background: rgba(18, 53, 36, 0.08);
      color: #123524;
    }
    &.confirmed {
      background: rgba(15, 124, 73, 0.08);
      color: #0f7c49;
    }
    &.pending {
      background: rgba(252, 152, 0, 0.08);
      color: #fc9800;
    }
    &.canceled {
      background: rgba(220, 53, 69, 0.08);
      color: #dc3545;
    }
    &.completed {
      background: rgba(197, 168, 128, 0.12);
      color: #C5A880;
    }
  }

  .right {
    text-align: right;
  }
`;

const H3 = styled.h3`
  font-weight: 700;
  font-size: 28px;
  color: #2D1F18;
  margin: 0;
  line-height: 1.2;
`;

const P = styled.p`
  font-weight: 500;
  font-size: 12px;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 4px 0 0 0;
  line-height: 1;
`;
